export const GOOGLE_SITE_KEY = '6Ld0q24aAAAAAPt-d1FDEN5TTz3nWN2bUPSduBrw';

export const FORMSPREE_URL = 'https://formspree.io/f/mjvpqjyz';
